import { createCookieStorage } from '@olxeu-eprivacy-storage/js';

const USER_ID_COOKIE = '__user_id_P&S';
const IS_COOKIE_CONSENT_REQUIRED = false;
const cookieStorage = createCookieStorage(IS_COOKIE_CONSENT_REQUIRED);

const set = (
  name: string,
  value: string,
  options: Record<string, string> = { path: '/' },
): void => {
  cookieStorage.set(name, value, options);
};

/* The main reason of using cookie setting like this is to be able to pass down a cookie
from PWA to a2b. Setting a specific domain will allow the cookie to be accessed on all
subdomains, while passing an empty string or no domain value (ex: using cookie.set) will set
a HOST ONLY cookie
*/
const setWithDomain = (name: string, value: string, env: string): void => {
  let domain = '';
  switch (env) {
  case 'development':
    break;
  case 'production':
    domain = 'olx.pl';
    break;
  default:
    domain = 'olx.org';
  }
  set(name, value, { domain, path: '/' });
};

const get = (name: string): string | null => {
  const cookieValue = cookieStorage.get(name);
  if (cookieValue) {
    return decodeURIComponent(cookieValue);
  }

  return null;
};

const remove = (name: string, domain = ''): void => {
  cookieStorage.remove(name, {
    path: '/',
    domain,
  });
};

export default {
  set,
  setWithDomain,
  get,
  remove,
  USER_ID_COOKIE,
};
